import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { ISelectOption } from 'src/app/interfaces/select.interfaces';
import { ProtocolControl } from 'src/app/interfaces/protocol.interfaces';

@Component({
    selector: 'protocol-control',
    templateUrl: 'protocol-control.component.html',
    styleUrls: ['./protocol-control.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: forwardRef(() => ProtocolControlComponent),
        },
    ],
    standalone: false
})
export class ProtocolControlComponent implements OnInit, ControlValueAccessor {
    @Input() public control?: ProtocolControl;
    // Устанавливает корректное значение в зависимости от типа данных
    @Input() public set value(value: ISelectOption | ISelectOption[]) {
        this.textValue = typeof value === 'string' ? value : '';
        this.selectValue = value || undefined;
    }
    @Input() public set options(options: ISelectOption[] | undefined | null) {
        if (options) {
            this.selectOptions =
                this.control?.type === 'select' ||
                this.control?.type === 'multi-select'
                    ? (options as ISelectOption[])
                    : [];
        }
    }
    @Input() public required = false;

    public onChange: any = () => {};
    public selectOptions: ISelectOption[] = [];

    public selectValue!: any;
    public textValue = '';

    public registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    public onTouched = (value: boolean) => {};
    public registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }
    public writeValue(value: any): void {
        // console.log(this.value);
        // this.control!.item.form_item_val_text = value;
        // this.control.
    }

    public constructor() {}

    public ngOnInit() {}

    public onTouchHandler() {
        this.onTouched(true);
    }

    public onChangeHandler(e: Event) {
        const target = e.target as HTMLInputElement;
        this.control!.item.formItemValText = target.value;
        this.onChange(target.value);
    }

    public onListSelectionHandler(e: ISelectOption) {
        const value = this.control?.item.formResultVals?.find(
            (item) => item.id === Number(e.value),
        );
        if (value && this.control) this.control.item.formResultVals = [value];
        this.onChange(e);
    }

    public onEnumSelectionHandler(e: ISelectOption[]) {
        if (this.control) {
            this.control.item.formResultVals = e.map((item) => {
                return { id: Number(item.value), text: item.text as string };
            });
        }
        this.onChange(e);
    }
}
